// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"bd29a452","374":"a5b0e4e5","432":"b4abfe7e","453":"da4f51ac","466":"f8ea6f28","507":"0b1220bf","696":"da987c92","903":"8798225e","923":"cae03d56"}[chunkId] + ".chunk.js";
};